import { container } from 'tsyringe';
import { CampaignService } from '@/core/campaign/services/CampaignService';
import type { CurrentUser } from '@/core/user/models/CurrentUser';
import { MergeCampaignIntoDTO } from '../DTO/MergeCampaignIntoDTO';

export const mergeCampaignIntoUseCase = async (input: MergeCampaignIntoDTO, user: CurrentUser): Promise<void> => {
  const campaignService = container.resolve<CampaignService>('CampaignService');

  return await campaignService.mergeInto(input, user);
};
